/** Normalize a search string to always start with `?` (or empty). */
export function normalizeSearch(search: string): string {
  if (!search) return '';
  return search.startsWith('?') ? search : `?${search}`;
}

/**
 * Core search identity for tab deduplication.
 * Ignores filters, mapping, source and other transient URL state.
 * Idents are order-insensitive so multi-select matches reliably.
 */
export function getSearchTabIdentity(search: string): string {
  const params = new URLSearchParams(normalizeSearch(search).slice(1));
  const view = (params.get('view') ?? '').toUpperCase();
  const tab = (params.get('tab') ?? '').toUpperCase();
  const identsRaw = params.get('idents') ?? '';
  const idents =
    identsRaw === 'ALL' || identsRaw === ''
      ? identsRaw
      : identsRaw.split('-').filter(Boolean).sort().join('-');
  return `view=${view}&idents=${idents}&tab=${tab}`;
}

export function searchesShareIdentity(a: string, b: string): boolean {
  return getSearchTabIdentity(a) === getSearchTabIdentity(b);
}

export function searchHasAppliedFilters(search: string): boolean {
  const params = new URLSearchParams(normalizeSearch(search).slice(1));
  if (params.get('f')) return true;
  for (const key of params.keys()) {
    if (key.startsWith('filters-') || key.startsWith('filters[')) return true;
  }
  return false;
}

/** Same entity (view + idents), ignoring association tab, source and filters. */
export function searchesShareEntity(a: string, b: string): boolean {
  const parse = (search: string) => {
    const params = new URLSearchParams(normalizeSearch(search).slice(1));
    const view = (params.get('view') ?? '').toUpperCase();
    const identsRaw = params.get('idents') ?? '';
    const idents =
      identsRaw === 'ALL' || identsRaw === ''
        ? identsRaw
        : identsRaw.split('-').filter(Boolean).sort().join('-');
    return `view=${view}&idents=${idents}`;
  };
  return parse(a) === parse(b);
}
